<template>
	<div class="r-facebook">
		<!-- <article v-if="firstAsset && assetType === 'text'">
      {{ block.adCopy }}
    </article> -->
		<video preload="metadata" playsinline v-if="firstAsset && assetType === 'video'" :poster="poster" controls>
			<source
				v-if="firstAsset.assetPath"
				:src="`${assetUrl}/${firstAsset.assetPath}`"
				type="video/mp4"
			/>
			Your browser does not support the video tag.
		</video>
		<img
			v-if="firstAsset && assetType === 'image'"
			:src="`${assetUrl}/${firstAsset.assetPath}`"
		/>
		<a
			v-if="!hideDownload && firstAsset && assetType !== 'carousel'"
			class="c-renderer__download"
			:href="downloadUrl(firstAsset.assetPath)"
		>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12.75 6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6V13.1893L8.53033 10.4697C8.23744 10.1768 7.76256 10.1768 7.46967 10.4697C7.17678 10.7626 7.17678 11.2374 7.46967 11.5303L11.4697 15.5303C11.7626 15.8232 12.2374 15.8232 12.5303 15.5303L16.5303 11.5303C16.8232 11.2374 16.8232 10.7626 16.5303 10.4697C16.2374 10.1768 15.7626 10.1768 15.4697 10.4697L12.75 13.1893V6ZM8 17.25C7.58579 17.25 7.25 17.5858 7.25 18C7.25 18.4142 7.58579 18.75 8 18.75H16C16.4142 18.75 16.75 18.4142 16.75 18C16.75 17.5858 16.4142 17.25 16 17.25H8Z"
					fill="currentColor"
				/>
			</svg>
		</a>
		<a
			v-if="!hideDownload && firstAsset && assetType === 'image'"
			class="c-renderer__clone"
			:href="downloadUrl(firstAsset.assetPath)"
		>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M13 7C13.5523 7 14 7.44772 14 8C14 10.3085 14.5108 11.7424 15.3842 12.6158C16.2576 13.4892 17.6915 14 20 14C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16C17.6915 16 16.2576 16.5108 15.3842 17.3842C14.5108 18.2576 14 19.6915 14 22C14 22.5523 13.5523 23 13 23C12.4477 23 12 22.5523 12 22C12 19.6915 11.4892 18.2576 10.6158 17.3842C9.74243 16.5108 8.30849 16 6 16C5.44772 16 5 15.5523 5 15C5 14.4477 5.44772 14 6 14C8.30849 14 9.74243 13.4892 10.6158 12.6158C11.4892 11.7424 12 10.3085 12 8C12 7.44772 12.4477 7 13 7ZM13 12.7334C12.7361 13.212 12.4147 13.6453 12.03 14.03C11.6453 14.4147 11.212 14.7361 10.7334 15C11.212 15.2639 11.6453 15.5853 12.03 15.97C12.4147 16.3547 12.7361 16.788 13 17.2666C13.2639 16.788 13.5853 16.3547 13.97 15.97C14.3547 15.5853 14.788 15.2639 15.2666 15C14.788 14.7361 14.3547 14.4147 13.97 14.03C13.5853 13.6453 13.2639 13.212 13 12.7334Z"
					fill="currentColor"
				/>
				<path
					d="M6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5C5 6.48063 4.78279 7.0726 4.4277 7.4277C4.0726 7.78279 3.48063 8 2.5 8C2.22386 8 2 8.22386 2 8.5C2 8.77614 2.22386 9 2.5 9C3.48063 9 4.0726 9.21721 4.4277 9.5723C4.78279 9.9274 5 10.5194 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 10.5194 6.21721 9.9274 6.5723 9.5723C6.9274 9.21721 7.51937 9 8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8C7.51937 8 6.9274 7.78279 6.5723 7.4277C6.21721 7.0726 6 6.48063 6 5.5Z"
					fill="currentColor"
				/>
				<path
					d="M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5C10 2.13341 9.85918 2.47538 9.66728 2.66728C9.47538 2.85918 9.13341 3 8.5 3C8.22386 3 8 3.22386 8 3.5C8 3.77614 8.22386 4 8.5 4C9.13341 4 9.47538 4.14082 9.66728 4.33272C9.85918 4.52462 10 4.86659 10 5.5C10 5.77614 10.2239 6 10.5 6C10.7761 6 11 5.77614 11 5.5C11 4.86659 11.1408 4.52462 11.3327 4.33272C11.5246 4.14082 11.8666 4 12.5 4C12.7761 4 13 3.77614 13 3.5C13 3.22386 12.7761 3 12.5 3C11.8666 3 11.5246 2.85918 11.3327 2.66728C11.1408 2.47538 11 2.13341 11 1.5Z"
					fill="currentColor"
				/>
			</svg>
		</a>

		<carousel
			:navigationEnabled="true"
			v-if="firstAsset && assetType === 'carousel'"
			:perPage="1"
		>
			<slide v-for="(asset, key) in block.assets" :key="key">
				<a
					v-if="!hideDownload"
					class="c-renderer__download"
					:href="downloadUrl(asset.assetPath)"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12.75 6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6V13.1893L8.53033 10.4697C8.23744 10.1768 7.76256 10.1768 7.46967 10.4697C7.17678 10.7626 7.17678 11.2374 7.46967 11.5303L11.4697 15.5303C11.7626 15.8232 12.2374 15.8232 12.5303 15.5303L16.5303 11.5303C16.8232 11.2374 16.8232 10.7626 16.5303 10.4697C16.2374 10.1768 15.7626 10.1768 15.4697 10.4697L12.75 13.1893V6ZM8 17.25C7.58579 17.25 7.25 17.5858 7.25 18C7.25 18.4142 7.58579 18.75 8 18.75H16C16.4142 18.75 16.75 18.4142 16.75 18C16.75 17.5858 16.4142 17.25 16 17.25H8Z"
							fill="currentColor"
						/>
					</svg>
				</a>
				<img
					v-if="asset.type === 'image'"
					:src="`${assetUrl}/${asset.assetPath}`"
				/>
				<video preload="metadata" playsinline v-else controls>
					<source
						v-if="asset.assetPath"
						:src="`${assetUrl}/${asset.assetPath}`"
						type="video/mp4"
					/>
					Your browser does not support the video tag.
				</video>
			</slide>
		</carousel>
	</div>
</template>

<script>
export default {
	props: {
		block: {},
		hideDownload: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		baseUrl: function () {
			return this.$store.getters['config/baseUrl'];
		},

		poster: function () {
			if (!this.firstAsset) {
				return;
			}

			let poster = this.firstAsset.cover;

			if (!poster) {
				return;
			}

			return `${this.assetUrl}/${this.firstAsset.cover.assetPath}`;
		},
		firstAsset: function () {
			let block = this.block;

			if (!block.assets) {
				return null;
			}

			let asset = block.assets[0];

			return asset;
		},
		// Guesses what kind of asset overall this block is about. Does a good enough job for now
		assetType: function () {
			return this.block.assetType;
			let firstAsset = this.firstAsset;
			let block = this.block;
			let assetType = '';
			if (block.assets && block.assets.length > 1) {
				assetType = 'carousel';
			} else {
				assetType = firstAsset.type;
			}
			return assetType;
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
	},

	methods: {
		downloadUrl: function (fileName) {
			let baseUrl = this.baseUrl;

			let str = `${this.assetUrl}/${fileName}`;

			return str;
		},
	},
};
</script>

<style lang="scss">
.r-facebook {
	width: 100%;
	height: 100%;
	position: relative;

	img,
	video {
		display: block;
		width: 100%;
		height: 100%;
	}

	// > article {
	//   width: 100%;
	//   height: 100%;
	//   overflow-y: auto;
	//   background-color: #fff;
	//   font-size: var(--font-size-xs);
	//   white-space: break-spaces;
	//   border-top: var(--color-bg-3) solid 1px;
	//   border-bottom: var(--color-bg-3) solid 1px;
	// }
}
</style>
